import React from 'react';
import twemoji from 'twemoji';

interface EmojiProps {
  emoji: string;
  size?: string;
}

const Emoji: React.FC<EmojiProps> = ({ emoji, size = '1em' }) => {
  const cssSizeClass = size.replace('.', '_');

  return (
    <>
      <span
        className={`emoji-icon size-${cssSizeClass}`}
        dangerouslySetInnerHTML={{ __html: twemoji.parse(emoji) }}
      />

      <style jsx global>{`
        .emoji-icon img {
          display: inline-block;
          vertical-align: -0.1em;
        }

        .emoji-icon.size-${cssSizeClass} img {
          height: ${size};
          width: ${size};
        }
      `}</style>
    </>
  );
};

export default Emoji;
